import React, { useState } from 'react';
import I18n from 'i18n-js';

import { RCCheckbox } from '@reverbdotcom/cadence/components';

export interface IProps {
  isOptedOut: boolean;
}

export default function SellingPoliciesPhotoRelistToggle({ isOptedOut }: IProps) {
  const [optIn, setOptIn] = useState(!isOptedOut);

  function handleClick() {
    const newOptIn = !optIn;
    setOptIn(newOptIn);
  }

  return (
    <>
      <RCCheckbox
        checked={optIn}
        onChange={handleClick}
        label={I18n.t('discovery.shopSettings.photoRelistPolicy.label')}
      />
      <div className="mt-2">
        <p className="form-section__description">
          {I18n.t('discovery.shopSettings.photoRelistPolicy.description1')}
        </p>
        <p className="form-section__description">
          {I18n.t('discovery.shopSettings.photoRelistPolicy.description2')}
        </p>
      </div>
      <input
        name="shop_policies_form[shop][opt_out_photo_relist]"
        id="shop_policies_form_opt_out_photo_relist"
        type="hidden"
        value={optIn ? '0' : '1'}
      />
    </>
  );
}
